import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "check-out__sum" };
var _hoisted_2 = { class: "cart-sum" };
var _hoisted_3 = { class: "cart-sum__main" };
var _hoisted_4 = { class: "cart-sum__list" };
var _hoisted_5 = {
    key: 3,
    class: "cart-sum__bottom"
};
import OrderSumBNPLSberbank from "./OrderSumBNPLSberbank.vue";
import OrderSumBNPLDolyame from "./OrderSumBNPLDolyame.vue";
import OrderSumPart from "./OrderSumPart.vue";
import OrderSumBNPLPodeli from "./OrderSumBNPLPodeli.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderSum',
    props: {
        orderSum: Number,
        deliveryPrice: Number,
        totalSum: Number,
        usedBonuses: Number,
        showBonuses: Boolean,
        paymentType: String,
    },
    setup: function (__props) {
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("dl", _hoisted_4, [
                            _createVNode(OrderSumPart, {
                                label: "Стоимость товаров",
                                amount: __props.orderSum,
                                "show-zero": ""
                            }, null, 8 /* PROPS */, ["amount"]),
                            _cache[0] || (_cache[0] = _createTextVNode()),
                            _createVNode(OrderSumPart, {
                                label: "Цена доставки",
                                amount: __props.deliveryPrice,
                                "show-zero": ""
                            }, null, 8 /* PROPS */, ["amount"]),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            _createVNode(OrderSumPart, {
                                label: "Оплачено бонусами",
                                amount: __props.usedBonuses,
                                "show-zero": __props.showBonuses
                            }, null, 8 /* PROPS */, ["amount", "show-zero"]),
                            _cache[2] || (_cache[2] = _createTextVNode()),
                            _createVNode(OrderSumPart, {
                                label: "Сумма к оплате",
                                amount: __props.totalSum,
                                "show-zero": ""
                            }, null, 8 /* PROPS */, ["amount"])
                        ])
                    ]),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    (__props.paymentType === 'sberbank_bnpl')
                        ? (_openBlock(), _createBlock(OrderSumBNPLSberbank, {
                            key: 0,
                            sum: __props.totalSum
                        }, null, 8 /* PROPS */, ["sum"]))
                        : _createCommentVNode("v-if", true),
                    _cache[4] || (_cache[4] = _createTextVNode()),
                    (__props.paymentType === 'dolyame')
                        ? (_openBlock(), _createBlock(OrderSumBNPLDolyame, {
                            key: 1,
                            sum: __props.totalSum
                        }, null, 8 /* PROPS */, ["sum"]))
                        : _createCommentVNode("v-if", true),
                    _cache[5] || (_cache[5] = _createTextVNode()),
                    (__props.paymentType === 'podeli')
                        ? (_openBlock(), _createBlock(OrderSumBNPLPodeli, {
                            key: 2,
                            sum: __props.totalSum
                        }, null, 8 /* PROPS */, ["sum"]))
                        : _createCommentVNode("v-if", true),
                    _cache[6] || (_cache[6] = _createTextVNode()),
                    (_ctx.$slots.default)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _renderSlot(_ctx.$slots, "default")
                        ]))
                        : _createCommentVNode("v-if", true)
                ])
            ]));
        };
    }
});
